import type { ComponentProps } from 'react';
import { Input } from '@zillow/constellation-10';
import InputMask from 'react-input-mask';

interface MaskedInputProps extends Omit<ComponentProps<'input'>, 'value' | 'onChange' | 'type'> {
  className: string;
  placeholder?: string;
  statekey?: string;
  error?: string | boolean;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  value: any;
  onChange: any;
  onFocus?: any;
  onBlur?: any;
  type?: string;
  mask?: string | null;
}
function MaskedInput({
  className = '',
  placeholder = '',
  statekey = '',
  error = '',
  name = '',
  disabled = false,
  required = false,
  value = '',
  onChange,
  onFocus = () => {},
  onBlur = () => {},
  type,
  mask = null,
  ...rest
}: MaskedInputProps): JSX.Element {
  return (
    <>
      <InputMask
        mask={mask}
        maskChar={null}
        value={value}
        name={name}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        data-statekey={statekey}
        className={className}
        error={Boolean(error)}
        required={required}
        disabled={disabled}
        type={type}
      >
        {(inputProps) => <Input {...inputProps} {...rest} error={Boolean(error)} />}
      </InputMask>
    </>
  );
}

export default MaskedInput;
